import React, {useState, useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {Waypoint} from '@homeaway/react-unveil';
import {logExperiment} from '@homeaway/abacus-client-utils';

import {SearchFormContainer} from '../SearchForm';
import {getElementHeight} from '../utils/search-form';
import {TESTS} from '../../../../utils/abacus';

import './StickySearchForm.less';

export function mapStateToProps({config}) {
    const {
        hasTouch,
        templateType: {isMultiDestination},
    } = config;
    return {hasTouch, isMultiDestination};
}

const wayPointClassName = 'StickyWaypoint';
const stickyActionLocation = 'sticky search form';

function StickySearchForm({isMultiDestination, hasTouch}) {
    const [isSticky, setIsSticky] = useState(false);
    const [rootMargin, setRootMargin] = useState('0px 0px 0px 0px');
    const shouldOpenDatePicker = !isMultiDestination;
    const [isOpen, setIsOpen] = useState(shouldOpenDatePicker);
    const stickyRef = useRef(null);

    useEffect(() => {
        if (hasTouch) {
            const top = getElementHeight(stickyRef);
            setRootMargin(`${top} 0px 0px 0px`);
        }
    }, [hasTouch]);

    const onEnter = () => {
        setIsSticky(false);
    };

    const onLeave = () => {
        logExperiment(TESTS.VRBO_LANDING_STICKY_SEARCHFORM);
        setIsSticky(true);
        setIsOpen(false);
    };

    const deviceType = hasTouch ? 'tablet' : 'desktop';

    const nonStickyActionLocation = isMultiDestination ? 'mlp' : 'slp';
    // istanbul ignore next (its not possible to test sticky behaviour in current implementation)
    const actionLocation = isSticky
        ? stickyActionLocation
        : nonStickyActionLocation;

    const searchFormOverrideProps = {
        datesOptions: {
            actionLocation,
            dateFormatOptions: {
                day: 'numeric',
                month: 'short',
                weekday: 'short',
            },
        },
        datesSettings: {
            isOpen,
        },
        destinationOptions: {
            actionLocation,
        },
        edapOptions: {
            searchQuerySubmittedEventActionLocation: actionLocation,
            searchSubmitEventActionLocation: actionLocation,
        },
        guestOptions: {
            actionLocation,
        },
    };
    const stickySearchFormClasses = classNames(
        'StickySearchFormWrapper',
        `StickySearchFormWrapper--${deviceType}`,
        {
            'StickySearchFormWrapper--sticky': isSticky,
        }
    );

    const spaceHolderStyle = {
        height: isSticky ? getElementHeight(stickyRef) : 0,
    };

    return (
        <>
            <Waypoint
                key={`rootMargin=${rootMargin}`}
                label="sticky-waypoint-top"
                onEnter={onEnter}
                onLeave={onLeave}
                rootMargin={rootMargin}
            >
                <div className={wayPointClassName} />
            </Waypoint>
            <div
                className={stickySearchFormClasses}
                ref={stickyRef}
                style={{top: '0px'}}
            >
                <SearchFormContainer
                    stickySearchFormDataOverrides={searchFormOverrideProps}
                />
            </div>
            <div style={spaceHolderStyle} />
        </>
    );
}

StickySearchForm.propTypes = {
    isMultiDestination: PropTypes.bool,
    hasTouch: PropTypes.bool,
};

StickySearchForm.defaultProps = {
    isMultiDestination: false,
    hasTouch: false,
};

export const StickySearchFormWrapper = connect(mapStateToProps)(
    StickySearchForm
);

StickySearchFormWrapper.displayName = 'StickySearchFormWrapper';
